import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ExternalApplicationOPEEnum} from "./ExternalApplicationOPEEnum";
import {ApiConfig} from "../../models/external-application/ApiConfig";

class O {
  id!: number;
}

/**
 * O Inner Class
 */
class I {
  id?: number;
  partitionId!: number;
  language?: string;
  email!: string;
  description!: string;
  enabled!: boolean;
  apiConfigMap!: Record<string, ApiConfig>;
  linkedPartitions?: number[];
}


/**
 * GetExternalApplicationCB class
 */
export class PutExternalApplicationCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ExternalApplicationOPEEnum.PutExternalApplication);
    this.i = new I();
    this.o = new O();
  }

}
